import React, { useEffect, useState } from 'react';
import  { Controller, useForm } from 'react-hook-form';
//import { useHistory } from 'react-router-dom';
//import { useGlobal } from 'reactn';
import api from '../../api';
import Button from '../common/button/Button';
import Card from '../common/card/Card';
//import Form, { Input } from '../common/form/Form';
import { Alert } from 'antd';

const EditCredentials = ({ match }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const form = useForm();
  const { register, handleSubmit, control, formState } = form;
  const { errors } = formState;


  const onSubmit = async (password) => {
    setLoading(true);
    if (password.password !== password.password2) {
      setErrorMessage('Passwords do not match');
      setLoading(false);
      return;
    }

    // delay feedback by at least 1 second
    setTimeout(async () => {
      const res = await api.changeUserPassword2(
        password.password,
        match.params
      );

      if (res && res.error) {
        setErrorMessage(res.error);
        // res.error is the backend validation error message
        setLoading(false);
        return;
      }
      window.location.reload();
    }, 1000);
    return;
  };

  return (
    <Card
      className="w-full lg:max-w-2xl"
      backgroundClass="bg-white"
      title="MCWA Customer Portal Change Password"
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col"
        errorMessage={errorMessage}
      >
          <label className="text-black" htmlFor="password">
            Password
          </label>
         <input type={!showPassword ? "password": "text"} id= "password"  
          control={control}
          disabled={loading}
          label="Password"
          error="errors.password" placeholder="Password" className=" ant-input p-4 my-2 h-auto text-lg border rounded-none" {...register("password", {required: {
            value: true, 
            message: "Password is required"}})}
            aria-invalid={errors.password ? "true" : "false"}       
          />
            { 
              <p className="text-red-500">{errors.password?.message} </p>
            }

          <label className="text-black" htmlFor="password2">
            Password
          </label>
         <input type={!showPassword ? "password": "text"} id= "password2"  
          control={control}
          disabled={loading}
          label="Confirm your Password"
          error="errors.password" placeholder="Confirm Password" className=" ant-input p-4 my-2 h-auto text-lg border rounded-none" {...register("password2", {required: {
            value: true, 
            message: "Password is required"}})}
            aria-invalid={errors.password2 ? "true" : "false"}       
          />
            { 
              <p className="text-red-500">{errors.password2?.message} </p>
            }

                    <p
              className="text-xs w-full text-right  cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {!showPassword ? 'Show Password' : 'Hide Password'}
            </p>

        <ul>
          <li>Password cannot be less than 8 characters</li>
          <li>Password must contain at least 2 lowercase letters</li>
          <li>Password must contain at least 2 uppercase letters</li>
          <li>Password must contain at least 2 numbers</li>
          <li>
            Password must contain at least 2 special characters (i.e. &*$%)
          </li>
          <li>Password cannot contain your name</li>
        </ul>
        <Button loading={loading} type ="submit" htmlType="submit">
          Change Password
        </Button>
            {errorMessage && (
               <Alert  description={errorMessage} type="error" role="alert"> 
               </Alert>                            
            )}
      </form>
    </Card>
  );
};

export default EditCredentials;
